import { render, staticRenderFns } from "./Rmmnjy.vue?vue&type=template&id=767868a2&scoped=true&"
import script from "./Rmmnjy.vue?vue&type=script&lang=js&"
export * from "./Rmmnjy.vue?vue&type=script&lang=js&"
import style0 from "./Rmmnjy.vue?vue&type=style&index=0&id=767868a2&lang=less&scoped=true&"
import style1 from "./Rmmnjy.vue?vue&type=style&index=1&id=767868a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767868a2",
  null
  
)

export default component.exports